<template>
  <section class="mv js-first-view" data-scroll-section>
    <div class="mv-in">
      <div class="container upper">
        <div class="in">
          <div
            data-scroll
            data-scroll-speed="1.25"
            data-scroll-delay="0.05"
            data-scroll-position="top"
            data-scroll-target=".mv"
            class="model model--tommy js-scroll-trigger"
            ref="tommy"
          >
            <img class="image" src="@/assets/mv-tommy.png" alt="" />
            <img class="tag" src="@/assets/tommy-tag.png" alt="" />
          </div>
          <div
            data-scroll
            data-scroll-speed="2"
            data-scroll-delay="0.1"
            data-scroll-position="top"
            data-scroll-target=".mv"
            class="model model--kanta js-scroll-trigger"
          >
            <img class="image" src="@/assets/mv-kanta.png" alt="" />
            <img class="tag" src="@/assets/kanta-tag.png" alt="" />
          </div>
          <svg
            class="tri tri-02"
            width="1440"
            height="619"
            viewBox="0 0 1540 719"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <mask id="MVTri02">
                <rect
                  class="mask-rect"
                  fill="white"
                  x="-40"
                  y="0"
                  width="1440"
                  height="619"
                />
              </mask>
            </defs>
            <path
              mask="url(#MVTri02)"
              d="M-55 0.499969L1418 618.999L1610.5 213.5L-55 0.499969Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <div class="container bottom">
        <div class="in">
          <div
            data-scroll
            data-scroll-speed="0.85"
            data-scroll-delay="0.05"
            data-scroll-position="top"
            data-scroll-target=".mv"
            class="model model--tokido js-scroll-trigger"
          >
            <img class="image" src="@/assets/mv-tokido.png" alt="" />
            <img
              data-scroll-speed="2"
              class="tag js-scroll-trigger"
              src="@/assets/tokido-tag.png"
              alt=""
            />
          </div>
          <div
            data-scroll
            data-scroll-speed="1.85"
            data-scroll-delay="0.05"
            data-scroll-position="top"
            data-scroll-target=".mv"
            class="model model--mishina js-scroll-trigger"
          >
            <img class="image" src="@/assets/mv-mishina.png" alt="" />
            <img
              data-scroll-speed="-2"
              class="tag js-scroll-trigger"
              src="@/assets/mishina-tag.png"
              alt=""
            />
          </div>
        </div>
        <svg
          class="tri tri-03 js-scroll-trigger"
          width="697"
          height="180"
          viewBox="0 0 697 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <mask id="MVTri03">
              <rect
                class="mask-rect"
                fill="white"
                x="0"
                y="0"
                width="697"
                height="180"
              />
            </mask>
          </defs>
          <path
            mask="url(#MVTri03)"
            d="M-15.3517 6.10352e-05L-15.3517 156.24L696.828 179.947L-15.3517 6.10352e-05Z"
            fill="white"
          />
        </svg>
      </div>

      <!--  Triangle -->
      <svg
        class="tri tri-01 js-scroll-trigger"
        width="711"
        height="145"
        viewBox="0 0 711 145"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <mask id="MVTri01">
            <rect
              class="mask-rect"
              fill="white"
              x="0"
              y="0"
              width="711"
              height="145"
            />
          </mask>
        </defs>
        <path
          mask="url(#MVTri01)"
          d="M338.705 -131.256L0.998596 -51.648L710.77 144.021L338.705 -131.256Z"
          fill="white"
        />
      </svg>

      <div class="mv__logo">
        <picture>
          <source type="image/webp" srcset="@/assets/logo.webp" />
          <img class="logo" src="@/assets/logo.png" alt="" />
        </picture>
        <img class="copy" src="@/assets/main-copy.png" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
import gsap from 'gsap'

/* mixin */
import scrollTrigger from '@/mixins/scrollTrigger.js'

export default {
  mixins: [scrollTrigger],

  watch: {
    async '$store.state.isShowView'(isShowView) {
      isShowView && this.onEnter()
    }
  },

  mounted() {
    this.setFillHeight()
  },

  methods: {
    setFillHeight() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    },

    onEnter() {
      const tl = gsap.timeline({
        delay: 0.5,
        onStart: () => this.setFillHeight()
      })

      tl.from(this.$el.querySelectorAll('.mask-rect'), {
        duration: 0.65,
        transform: (i) => {
          return i === 1 ? 'translate3d(-100%,0,0)' : 'translate3d(100%,0,0)'
        },
        ease: 'expo.out'
      })

      tl.from(
        this.$el.querySelectorAll('.model'),
        {
          duration: 1.2,
          skewX: -6,
          scale: 1.1,
          x: (i) => {
            let x = 0
            switch (i) {
              case 0:
                x = 50
                break
              case 1:
                x = -50
                break
              case 2:
                x = -50
                break
              case 3:
                x = 50
                break
            }
            return x
          },
          y: (i) => {
            let y = 0
            switch (i) {
              case 0:
                y = -50
                break
              case 1:
                y = -50
                break
              case 2:
                y = -50
                break
              case 3:
                y = -50
                break
            }
            return y
          },
          opacity: 0,
          ease: 'expo.out',
          stagger: 0.05
        },
        '-=0.45'
      )

      tl.from(
        this.$el.querySelector('.mv__logo'),
        {
          duration: 0.65,
          opacity: 0,
          skewX: -16,
          x: 100,
          y: -40,
          ease: 'elastic.out(1.5, 1.2)'
        },
        '-=0.65'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.mv {
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  background: linear-gradient(to right, #e70013, #bd0414);

  .mv-in {
    position: relative;
    width: 100%;
    max-width: 1800px;
    height: 100%;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    z-index: 0;
    overflow: hidden;

    .container {
      position: relative;
      width: 100%;
      height: 50vh;
      height: calc(var(--vh, 1vh) * 50);
      transform: skewY(-6deg);
      overflow: hidden;

      &.upper {
        height: calc(var(--vh, 1vh) * 51);
      }

      &.bottom {
        height: calc(var(--vh, 1vh) * 50);
      }
      .in {
        width: 100%;
        height: 100%;
        transform: skewY(6deg);
      }
    }

    .model {
      position: absolute;
      z-index: 0;

      &--tommy {
        width: 120vw;
        top: 3rem;
        right: -46vw;

        .image {
          width: 100%;
          backface-visibility: hidden;
        }

        .tag {
          position: absolute;
          top: 34vw;
          left: 46vw;
          width: 11rem;
          backface-visibility: hidden;
        }
      }
      &--kanta {
        width: 84vw;
        left: -15vw;
        top: 5rem;
        z-index: -8;
        .image {
          width: 100%;
          backface-visibility: hidden;
        }
        .tag {
          position: absolute;
          top: 34vw;
          left: 10vw;
          width: 12rem;
          backface-visibility: hidden;
        }
      }
      &--tokido {
        width: 124vw;
        left: -16vw;
        top: 2rem;
        z-index: -9;
        .image {
          width: 100%;
          backface-visibility: hidden;
        }
        .tag {
          position: absolute;
          top: 40vw;
          left: 16vw;
          width: 12rem;
          backface-visibility: hidden;
        }
      }

      &--mishina {
        width: 105vw;
        top: 0rem;
        left: 11vw;
        .image {
          width: 100%;
          backface-visibility: hidden;
        }
        .tag {
          position: absolute;
          top: 40vw;
          left: 34vw;
          width: 14rem;
          backface-visibility: hidden;
        }
      }
    }

    .tri {
      position: absolute;
      &.tri-01 {
        z-index: -9;
      }

      &.tri-02 {
        width: 320vw;
        top: calc(var(--vh, 1vh) * 40);
        left: 0;
        z-index: -10;
        transform: scale(1.6);
      }

      &.tri-03 {
        display: none;
        width: 178vw;
        left: -10vw;
        top: -30vw;
        transform: rotate(-15deg);
        z-index: -9;
      }
    }
  }

  &__logo {
    position: absolute;
    top: calc(calc(var(--vh, 1vh) * 50) + -4rem);
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;

    .logo {
      width: 80vw;
      backface-visibility: hidden;
    }

    .copy {
      position: absolute;
      top: 5.5rem;
      left: 15rem;
      width: 30vw;
      backface-visibility: hidden;
    }
  }
}
</style>
